module.exports = __webpack_public_path__ + "static/img/图层 16.8810ff5f.png";